export default class gameProgress {
  title: string;
  completionStatus: boolean;

  constructor(_title: string, _completionStatus: boolean) {
    this.title = _title;
    this.completionStatus = _completionStatus;
  }
}
